import { KeyboardKeysType } from '../types/keyboard-keys';

export type ValueOf<T> = T[keyof T];

export const KeyboardKeys = {
    Space: 'Space',
    Escape: 'Escape',
    ArrowRight: 'ArrowRight',
    ArrowLeft: 'ArrowLeft',
    ArrowUp: 'ArrowUp',
    ArrowDown: 'ArrowDown',
    KeyK: 'KeyK',
    KeyL: 'KeyL',
    KeyJ: 'KeyJ',
    KeyF: 'KeyF',
    KeyM: 'KeyM',
    Home: 'Home',
    End: 'End',
    PageUp: 'PageUp',
    PageDown: 'PageDown',
} as const;

export const KEYBOARD_KEY_CODES = Object.values(KeyboardKeys);

export const DEFAULT_GLOBAL_KEYBOARD_HANDLER_TOGGLERS = <
    Record<ValueOf<typeof KeyboardKeys>, boolean>
>Object.fromEntries(Object.values(KeyboardKeys).map((key) => [key, true]));

export const REPEATABLE_KEY_CODES: KeyboardKeysType[] = [
    KeyboardKeys.ArrowDown,
    KeyboardKeys.ArrowUp,
    KeyboardKeys.ArrowLeft,
    KeyboardKeys.ArrowRight,
    KeyboardKeys.KeyJ,
    KeyboardKeys.KeyL,
];
